import {
  Filter,
  GroupFilter,
  InputFilter,
  InputType,
} from "../../types/filter";

export const isGroupFilter = (filter: Filter): filter is GroupFilter => {
  return filter.inputType === InputType.Group;
};
export const isInputFilter = (filter: Filter): filter is InputFilter => {
  return filter.inputType !== InputType.Group;
};
export const findFilterFromFilters = (filters: Filter[], filterId: string) => {
  return filters
    .flatMap((filter) => (isInputFilter(filter) ? filter : filter.filters))
    .find(({ id }) => id === filterId);
};
